import { ListItem } from "@mui/material";
import { useCurrentUser } from "src/business-hooks/useCurrentUser";
import UserAvatar from "src/components/UserAvatar/UserAvatar";
import { userFullName } from "src/utils/user";
import TopbarUserInfoDebug from "./components/TopbarUserInfoDebug/TopbarUserInfoDebug";

export default function TopbarUserInfo() {
  const user = useCurrentUser();
  const fullName = userFullName(user);

  return (
    <ListItem className="block">
      <div className="flex items-center gap-3 w-full">
        <UserAvatar user={user} />
        <div className="flex flex-col flex-1">
          {fullName && <span className="font-medium">{fullName}</span>}
          <span className="text-sm text-grey-500">{user?.email}</span>
        </div>
      </div>
      <TopbarUserInfoDebug />
    </ListItem>
  );
}
